import React from 'react'
import { motion } from 'framer-motion'
import Testimonials from '../components/Testimonials'
import SEOMetaTags from '../components/SEOMetaTags'

const TestimonialsPage = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "NorCal Cane Corso Puppies",
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "5.0",
      "reviewCount": "200",
      "bestRating": "5",
      "worstRating": "1"
    },
    "review": [
      {
        "@type": "Review",
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "5",
          "bestRating": "5"
        },
        "author": {
          "@type": "Person",
          "name": "Sarah M."
        },
        "reviewBody": "We reserved our Cane Corso and the process was smooth from start to finish. Weekly photo updates and clear communication. Highly recommend!",
        "datePublished": "2024-01-15"
      },
      {
        "@type": "Review",
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "5",
          "bestRating": "5"
        },
        "author": {
          "@type": "Person",
          "name": "Daniel K."
        },
        "reviewBody": "Picked up our puppy last weekend. Healthy, confident, and exactly as described. The team answered every question promptly.",
        "datePublished": "2024-01-20"
      },
      {
        "@type": "Review",
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "5",
          "bestRating": "5"
        },
        "author": {
          "@type": "Person",
          "name": "Olivia R."
        },
        "reviewBody": "Excellent service! They helped us choose the right temperament for our family. Our girl settled in immediately.",
        "datePublished": "2024-02-01"
      },
      {
        "@type": "Review",
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "5",
          "bestRating": "5"
        },
        "author": {
          "@type": "Person",
          "name": "Jacob T."
        },
        "reviewBody": "Very professional breeder. Vet records were complete, and pickup day was organized. Our boy is thriving.",
        "datePublished": "2024-02-10"
      },
      {
        "@type": "Review",
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "5",
          "bestRating": "5"
        },
        "author": {
          "@type": "Person",
          "name": "Aisha B."
        },
        "reviewBody": "We reserved months in advance and got regular updates. The puppy came well socialized and crate‑trained basics. Wonderful experience.",
        "datePublished": "2024-02-15"
      }
    ]
  }

  return (
    <>
      <SEOMetaTags
        title="Customer Testimonials & Reviews"
        description="Read authentic reviews from happy Cane Corso families. See why 200+ customers trust NorCal Cane Corso Puppies for their premium Italian Mastiff puppies. 5-star rated breeder with exceptional service."
        keywords="Cane Corso reviews, customer testimonials, dog breeder reviews, Northern California, satisfied customers, 5-star breeder, Italian Mastiff testimonials"
        canonical="/testimonials"
        ogTitle="Customer Reviews - NorCal Cane Corso Puppies Testimonials"
        ogDescription="Discover what our happy customers say about their Cane Corso puppies. 200+ five-star reviews from families who found their perfect companion with us."
        structuredData={structuredData}
      />
      
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="page-wrapper"
      >
        <Testimonials />
      </motion.div>
    </>
  )
}

export default TestimonialsPage